module.exports = __webpack_public_path__ + "img/marker-oil-transport-yellow.a525c363.png";